import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import StepRoutes from "../../../Routes/steps_routes";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import LoadingPage from "../../../Components/layouts/loading";
import { extractDate } from "../../../Components/Functions/date.fun";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { BsExclamationTriangleFill, BsCheck2Square } from "react-icons/bs";

const ViewClientProject = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [userData, setUserData] = useState();
  const [refresh, setRefresh] = useState(false);
  let { id } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/clientProject/getCpById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data.cpStatus);
          setUserData(res.data.getUserDetails);
        } else {
          Toast("error", "Error while getting Lead!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id, refresh]);

  const handelSubmit = () => {
    document.getElementById("open-modal").click();
  };

  const disableCred = (payload) => {
    performRequest("PATCH", `/clientProject/diableCp/${id}`, { email: payload })
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Credential disabled!");
          navigate("/client-projects");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };
  const changeToFarmerParner = () => {
    performRequest("PATCH", `/login/update/${userData?.id}`, {
      additionalRole: "farmer partner",
    })
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "New Role assigned to client as 'farmerPartner'");
          setRefresh(!refresh);
        } else {
          Toast("error", "error while updating");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };
  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">View Client Project</h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">
                {(data?.cpNumber || "N/A").toUpperCase()}
              </h2>
            </div>

            <div className="card-body row">
              <div className="col-md border-end">
                {data && (
                  <div className="mb-3 row">
                    <label className="w-25 form-label col">Name</label>
                    <div className="w-100 col">
                      {(data?.clientName || "N/A").toUpperCase()}
                    </div>
                  </div>
                )}
                {data && (
                  <div className="mb-3 row">
                    <label className="w-25 form-label col">Email</label>
                    <div className="w-100 col">
                      {(data?.clientEmail || "N/A").toUpperCase()}
                    </div>
                  </div>
                )}
                {data && (
                  <div className="mb-3 row">
                    <label className="w-25 form-label col">
                      Client Phone number
                    </label>
                    <div className="w-100 col">
                      <div className="w-100 col">
                        {data?.clientContactNumber || "N/A"}
                      </div>
                    </div>
                  </div>
                )}
                {data && (
                  <div className="mb-3 row">
                    <label className="w-25 form-label col">Business name</label>
                    <div className="w-100 col">
                      {(data?.businessName || "N/A").toUpperCase()}
                    </div>
                  </div>
                )}
                {data && (
                  <div className="mb-3 row">
                    <label className="w-25 form-label col">Business type</label>
                    <div className="w-100 col">
                      {(data?.businessType || "N/A").toUpperCase()}
                    </div>
                  </div>
                )}
                {data && (
                  <div className="mb-3 row">
                    <label className="w-25 form-label col">
                      Business gst number
                    </label>
                    <div className="w-100 col">
                      {data?.businessGstNumber || "N/A"}
                    </div>
                  </div>
                )}
                {data && (
                  <div className="mb-3 row">
                    <label className="w-25 form-label col">Project date</label>
                    <div className="w-100 col">
                      {(data?.createdAt && extractDate(data?.createdAt)) ||
                        "N/A"}
                    </div>
                  </div>
                )}
              </div>
              <div className="col-md">
                {data && (
                  <div className="mb-3 row">
                    <label className="w-25 form-label col">
                      Aadhar card number
                    </label>
                    <div className="w-100 col">
                      {(data?.aadharcardNumber || "N/A").toUpperCase()}
                    </div>
                  </div>
                )}
                {data && (
                  <div className="mb-3 row">
                    <label className="w-25 form-label col">
                      Billing address
                    </label>
                    <div className="w-100 col">
                      {(`${data?.billingAddress}` || "N/A").toUpperCase()}
                    </div>
                  </div>
                )}

                {data && (
                  <div className="mb-3 row">
                    <label className="w-25 form-label col">
                      Primary farm address
                    </label>
                    <div className="w-100 col">
                      {(data?.farmAddress || "N/A").toUpperCase()}
                    </div>
                  </div>
                )}
                {data && (
                  <div className="mb-3 row">
                    <label className="w-25 form-label col">Farm pincode</label>
                    <div className="w-100 col">
                      {data?.farmPinCode || "N/A"}
                    </div>
                  </div>
                )}
                {data && (
                  <div className="mb-3 row">
                    <label className="w-25 form-label col">Pan number</label>
                    <div className="w-100 col">
                      {(data?.panNumber || "N/A").toUpperCase()}
                    </div>
                  </div>
                )}
                {data && (
                  <div className="mb-3 row">
                    <label className="w-25 form-label col">Generated by</label>
                    <div className="w-100 col">
                      {(data?.generatedBy || "N/A").toUpperCase()}
                    </div>
                  </div>
                )}
                {data && (
                  <div className="mb-3 row">
                    <label className="w-25 form-label col">
                      Progress Status
                    </label>

                    {
                      <div className="w-100 col">
                        {(
                          (data?.progressStatus &&
                            (data?.progressStatus).join(", ")) ||
                          "N/A"
                        ).toUpperCase()}
                      </div>
                    }
                  </div>
                )}
                {data && (
                  <div className="mb-3 row">
                    <label className="w-25 form-label col">Notes</label>
                    <div className="w-100 col">
                      {(data?.notes || "N/A").toUpperCase()}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="card-footer">
              <div className="btn-list justify-content-end">
                <button
                  className="btn mx-1 mt-2 btn-danger"
                  onClick={() => handelSubmit()}
                  disabled={data?.refund}
                >
                  <BsExclamationTriangleFill className="fs-2 me-2" />
                  Mark Refund
                </button>
                <button
                  className="btn mx-1 mt-2 btn-primary"
                  onClick={() => changeToFarmerParner()}
                  disabled={userData?.additionalRole}
                >
                  <BsCheck2Square className="fs-2 me-2" />
                  {userData?.additionalRole === "farmer partner"
                    ? "ALREADY FARMER PARTNER"
                    : "CHANGE TO FARMER PARNER"}
                </button>
                <SimpleButton
                  buttonText="Edit Client Project"
                  href={`/client-projects/edit/${id}`}
                />

                <SimpleButton buttonText="Cancel" type="secondary" />
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal modal-blur fade"
          id="modal-danger"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-sm modal-dialog-centered"
            role="document"
          >
            <div className="modal-content">
              <span
                id="open-modal"
                data-bs-toggle="modal"
                data-bs-target="#modal-danger"
              ></span>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
              <div className="modal-status bg-warning"></div>
              <div className="modal-body text-center py-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="icon mb-2 text-warning icon-lg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  stroke="currentColor"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M10.24 3.957l-8.422 14.06a1.989 1.989 0 0 0 1.7 2.983h16.845a1.989 1.989 0 0 0 1.7 -2.983l-8.423 -14.06a1.989 1.989 0 0 0 -3.4 0z" />
                  <path d="M12 9v4" />
                  <path d="M12 17h.01" />
                </svg>
                <h3>Are you sure about disabled credentials?</h3>
                <div className="text-muted">
                  Do you really want to disabled credentials? This will not
                  allowed{" "}
                  <span className="fs-4 fw-bolder">{data?.clientName}</span> to
                  login our portal.
                </div>
              </div>
              <div className="modal-footer">
                <div className="w-100">
                  <div className="row">
                    <div className="col">
                      <button className="btn w-100" data-bs-dismiss="modal">
                        Cancel
                      </button>
                    </div>
                    <div className="col">
                      <button
                        className="btn btn-danger w-100"
                        data-bs-dismiss="modal"
                        onClick={() => disableCred(data?.clientEmail)}
                      >
                        Disable Credentials
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ViewClientProject;
